<!--
 * @Author: your name
 * @Date: 2021-06-23 01:14:37
 * @LastEditTime: 2021-07-25 20:24:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\components\toast.vue
-->
<template>
  <div>
    <div class="n_toast" v-if="isToast">{{message}}</div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
    },
    isToast: {
      type: Boolean,
    },
  },
  data() {
    return {
      // isToast: false,
    }
  },
  watch: {
    // isToast(val) {
    //   console.log('1111', val)
    //   // if (val == true) {
    //   //   this.isToast = false
    //   // }
    // },
  },
}
</script>

<style scoped lang="scss">
.n_toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 15px 20px;
  font-size: 24px;
  border-radius: 15px;
  z-index: 99;
}
</style>